/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedInstancesIndexRouteImport } from './routes/_authenticated.instances.index'
import { Route as AuthenticatedInstancesIdRouteImport } from './routes/_authenticated.instances.$id'
import { Route as AuthenticatedInstancesNewRouteImport } from './routes/_authenticated.instances.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedInstancesIndexRoute =
  AuthenticatedInstancesIndexRouteImport.update({
    id: '/instances/',
    path: '/instances/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstancesIdRoute =
  AuthenticatedInstancesIdRouteImport.update({
    id: '/instances/$id',
    path: '/instances/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstancesNewRoute =
  AuthenticatedInstancesNewRouteImport.update({
    id: '/instances/new',
    path: '/instances/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/instances/$id': typeof AuthenticatedInstancesIdRoute
  '/instances/new': typeof AuthenticatedInstancesNewRoute
  '/instances/': typeof AuthenticatedInstancesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/instances/$id': typeof AuthenticatedInstancesIdRoute
  '/instances/new': typeof AuthenticatedInstancesNewRoute
  '/instances': typeof AuthenticatedInstancesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/instances/$id': typeof AuthenticatedInstancesIdRoute
  '/_authenticated/instances/new': typeof AuthenticatedInstancesNewRoute
  '/_authenticated/instances/': typeof AuthenticatedInstancesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    '/' | '/login' | '/instances/$id' | '/instances/new' | '/instances/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/login' | '/instances/$id' | '/instances/new' | '/instances'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/instances/$id'
    | '/_authenticated/instances/new'
    | '/_authenticated/instances/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/instances/': {
      id: '/_authenticated/instances/'
      path: '/instances'
      fullPath: '/instances/'
      preLoaderRoute: typeof AuthenticatedInstancesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instances/$id': {
      id: '/_authenticated/instances/$id'
      path: '/instances/$id'
      fullPath: '/instances/$id'
      preLoaderRoute: typeof AuthenticatedInstancesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instances/new': {
      id: '/_authenticated/instances/new'
      path: '/instances/new'
      fullPath: '/instances/new'
      preLoaderRoute: typeof AuthenticatedInstancesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedInstancesIdRoute: typeof AuthenticatedInstancesIdRoute
  AuthenticatedInstancesNewRoute: typeof AuthenticatedInstancesNewRoute
  AuthenticatedInstancesIndexRoute: typeof AuthenticatedInstancesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedInstancesIdRoute: AuthenticatedInstancesIdRoute,
  AuthenticatedInstancesNewRoute: AuthenticatedInstancesNewRoute,
  AuthenticatedInstancesIndexRoute: AuthenticatedInstancesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
